import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";


export default function Product(props) {
    return (
        <div className='product-container'>
            <div className='product-image'>
                <a className='pdp-anchor' href={props.PDPUrl} target='_blank'><img src={props.image}></img>
                <div className="product-image-overlay">
                    <div className="product-price-text">{`$${props.price}`}</div>
                    </div>
                </a>
                <p>{props.status}</p>
            </div>
            <div className='product-title'>
                <a href={props.PDPUrl} className='pdp-anchor'><div>{props.title}</div></a>
            </div>
            {/* <div className='product-price'>
                {`$${props.price}`}
            </div> */}
            {props.showAddToCart &&
                <div className='product-addtocart'>
                    <button>Add to cart</button>
                </div>
            }
            {props.lastProductElementRef &&
                < div ref={props.lastProductElementRef}></div>
            }
        </div>
    )
}

Product.propTypes = {
    title: PropTypes.string.isRequired,
    image: PropTypes.string,
    price: PropTypes.string.isRequired,
    campareAtPrice: PropTypes.string,
    showAddToCart: PropTypes.bool.isRequired,
    PDPUrl: PropTypes.string.isRequired
};


